var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.8327C5.39697 18.8327 1.66602 15.1017 1.66602 10.4993C1.66602 5.89697 5.39697 2.16602 9.99935 2.16602C14.6017 2.16602 18.3327 5.89697 18.3327 10.4993C18.3327 15.1017 14.6017 18.8327 9.99935 18.8327ZM9.99935 17.166C13.6813 17.166 16.666 14.1813 16.666 10.4993C16.666 6.81745 13.6813 3.83268 9.99935 3.83268C6.31745 3.83268 3.33268 6.81745 3.33268 10.4993C3.33268 14.1813 6.31745 17.166 9.99935 17.166ZM6.66602 12.166H13.3327V13.8327H6.66602V12.166Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24935 7.49935C7.93971 7.49935 8.49935 8.05902 8.49935 8.74935C8.49935 9.43968 7.93971 9.99935 7.24935 9.99935C6.55899 9.99935 5.99935 9.43968 5.99935 8.74935C5.99935 8.05902 6.55899 7.49935 7.24935 7.49935ZM13.0827 7.49935C13.773 7.49935 14.3327 8.05902 14.3327 8.74935C14.3327 9.43968 13.773 9.99935 13.0827 9.99935C12.3924 9.99935 11.8327 9.43968 11.8327 8.74935C11.8327 8.05902 12.3924 7.49935 13.0827 7.49935Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.51c80e31e4a32d7cb18a9b5f1790663d.svg";
export { ForwardRef as ReactComponent };